import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';

import StepConnector from '@material-ui/core/StepConnector';

import DialogComp from '../../../../Core/Dialog/DialogComp';
import { getVehicleContractStatusStepper, VehicleContractReport } from '../../../../Core/Services/InternalUser/InternalDashService';
import CompleteScheduleModalForContract from './statusModals/completeSchedule';
import ContractSetDeliveryDateModal from './statusModals/ContractSetDeliveryDateModal';
import ContractSetCollectedModal from './statusModals/ContractSetCollectedModal';
import ContractSetOnsiteDateModal from './statusModals/ContractSetOnsiteDateModal';
import ContractSetOffHireModal from './statusModals/ContractSetOffHireModal';
import ContractSetVehiclePickedModal from './statusModals/ContractSetVehiclePickedModal';
import ContractSetAwaitingFactoryInspection from './statusModals/ContractSetAwaitingFactoryInspection';
import { Grid, Tooltip } from '@material-ui/core';

import BuildIcon from '@material-ui/icons/Build';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import SnoozeIcon from '@material-ui/icons/Snooze';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import ContractSetPauseCompleted from './statusModals/ContractSetPausedComplete';
import ContractSetResume from './statusModals/ContractSetResumeContract';
import ContractOffHireOverRide from './statusModals/OffHireOverRide';
import moment from 'moment';
import { useWindowSize } from '../../../../Core/Hooks/useWindowSize';
import DescriptionIcon from '@material-ui/icons/Description';
import ConfirmationModal from '../../../../Core/Modal/ConfirmationModal';
import { useToast } from '../../../../Core/Hooks/useToast';
import { downloadUploadedFile } from '../../../../Core/Services/FileUploaderService';
import { getConfigIdFromName } from '../../../../Core/Controls/GenericFileUploader/FileUploaderConfig';
import SingleDocumentViewer from '../../../../Core/Controls/GenericFileUploader/DocumentViewer';
import VisibilityIcon from '@material-ui/icons/Visibility';

const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 15
    },
    active: {
        '& $line': {
            backgroundImage: 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)'
        }
    },
    completed: {
        '& $line': {
            // backgroundImage: 'linear-gradient( 136deg, #0f9b0f  0%, #0b4d0b 80%, #031a03 100%)'
            backgroundImage: 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)'
        }
    },
    line: {
        height: 5,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1
    }
})(StepConnector);

const QontoConnector = withStyles({
    alternativeLabel: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)'
    },
    active: {
        '& $line': {
            borderColor: 'red'
        }
    },
    completed: {
        '& $line': {
            borderColor: 'red'
        }
    },
    line: {
        borderColor: '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1
    }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: 'black',
        width: 35,
        height: 35,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        '@media(max-width: 1024px)': {
            width: 22,
            height: 22 // Adjust height for devices between 821px and 1024px
        }
    },
    active: {
        backgroundImage: 'linear-gradient( 136deg, #0f9b0f  30%, #0b4d0b 80%, #031a03 100%)',
        // backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        cursor: 'pointer',
        color: '#fff'
    },
    contract: {
        backgroundImage: 'linear-gradient(136deg, #FFD700 0%, #FFC107 50%, #FFB300 100%)', // yellowish gradient
        color: '#000',
        boxShadow: '0 4px 10px 0 rgba(255, 215, 0, 0.5)' // soft yellow glow
    },
    completed: {
        // backgroundImage: 'linear-gradient( 136deg, #0f9b0f  30%, #0b4d0b 80%, #031a03 100%)',
        backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',

        color: '#fff'
    }
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed, contractDeliveryDate, activeStep } = props;

    // const styles = {
    //     backgroundColor: active ? 'green' : '#ccc', // Green when active, grey otherwise
    //     width: 50,
    //     height: 50,
    //     borderRadius: '50%',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center'
    // };

    const icons = {
        1: (
            <BuildIcon
                style={{ fontSize: 16 }}
                // className={clsx({
                //     [classes.contract]: contractDeliveryDate // 💛 yellow highlight condition
                // })}
            />
        ),
        2: <LocalShippingIcon style={{ fontSize: 16 }} />,
        3: <EmojiTransportationIcon style={{ fontSize: 16 }} />,
        4: <BuildIcon style={{ fontSize: 16 }} />,
        5: <EmojiTransportationIcon style={{ fontSize: 16 }} />,
        6: <SnoozeIcon style={{ fontSize: 16 }} />,
        7: <BuildIcon style={{ fontSize: 16 }} />,
        8: <LocalShippingIcon style={{ fontSize: 16 }} />,
        9: <BuildIcon style={{ fontSize: 16 }} />,
        10: <SnoozeIcon style={{ fontSize: 16 }} />
    };

    const getStepClass = () => {
        if (contractDeliveryDate && activeStep == 0 && Number(props.icon) === 1) return clsx(classes.root, classes.contract);
        if (completed) return clsx(classes.root, classes.completed);
        if (active) return clsx(classes.root, classes.active);
        return classes.root;
    };

    // return (
    //     <div
    //         className={clsx(classes.root, {
    //             [classes.active]: active,
    //             [classes.completed]: completed
    //             // [classes.contract]: contractDeliveryDate // 💛 yellow highlight condition
    //         })}
    //     >
    //         {icons[String(props.icon)]}
    //     </div>
    // );

    return <div className={getStepClass()}>{icons[String(props.icon)]}</div>;
}

ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node
};

function ColorlibStepIconTab(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    // const styles = {
    //     backgroundColor: active ? 'green' : '#ccc', // Green when active, grey otherwise
    //     width: 50,
    //     height: 50,
    //     borderRadius: '50%',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center'
    // };

    const icons = {
        1: <BuildIcon style={{ fontSize: 8 }} />,
        2: <LocalShippingIcon style={{ fontSize: 8 }} />,
        3: <EmojiTransportationIcon style={{ fontSize: 8 }} />,
        4: <BuildIcon style={{ fontSize: 8 }} />,
        5: <EmojiTransportationIcon style={{ fontSize: 8 }} />,
        6: <SnoozeIcon style={{ fontSize: 8 }} />,
        7: <BuildIcon style={{ fontSize: 8 }} />,
        8: <LocalShippingIcon style={{ fontSize: 8 }} />,
        9: <BuildIcon style={{ fontSize: 8 }} />,
        10: <SnoozeIcon style={{ fontSize: 8 }} />
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

ColorlibStepIconTab.propTypes = {
    active: PropTypes.bool,
    completed: PropTypes.bool,
    icon: PropTypes.node
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& .MuiStepper-root': {
            padding: '10px 5px'
        }
    },
    button: {
        marginRight: theme.spacing(1)
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    stepperlabel: { marginTop: -10 },
    stepLabel: {
        fontSize: 14,
        '@media(max-width:1024px)': {
            fontSize: 12,
            fontWeight: 600
        }
    },
    stepAssign: {
        fontSize: 10,
        fontWeight: 700,
        '@media(max-width:1024px)': {
            fontSize: 8,
            fontWeight: 600
        }
    },
    stepdate: {
        fontSize: 10,
        fontWeight: 700,
        '@media(max-width:1024px)': {
            fontSize: 8,
            fontWeight: 600
        }
    }
}));

export default function ContractStepper(props) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(1);
    const [changeStatus, setChangeStatus] = React.useState(false);
    const [openDialog, setOpenDialog] = useState({});
    const [documentState, setDocumentState] = useState({
        imageList: [],
        slectedFileExt: '',
        slectedFileName: '',
        openModal: false,
        docType: '',
        docUniqueName: '',
        isBtnLoader: false
    });
    const [modalStep, setModalStep] = React.useState(-1);
    const [state, setState] = useState({
        modalIndex: 0,
        modalLabel: '',
        65: [],
        resData: {},
        // checkedVehicleList: [props.vehicleID],
        isUpdate: '',
        summerServiceScheduleID: null,
        onhireScheduleID: null,
        offhireScheduleID: null,
        factoryInspectionScheduleID: null,
        steps: []
    });

    const [width, height] = useWindowSize();
    const { showToastSuccess, showToastError } = useToast();

    useEffect(() => {
        async function fetchDropdown() {
            try {
                if (props.vehicleID) {
                    let res = await getVehicleContractStatusStepper(props.vehicleID);
                    if (res.success) {
                        let data = res?.data?.details.table[0];
                        switch (data.contractStatusID) {
                            case 1:
                                setActiveStep(0);

                                break;
                            case 2:
                                setActiveStep(1);
                                break;
                            case 3:
                                setActiveStep(1);
                                break;
                            case 4:
                                setActiveStep(2);
                                break;
                            case 5:
                                setActiveStep(3);
                                break;
                            case 6:
                                // setActiveStep(data.contractWinterEndDate && moment(data.contractWinterEndDate).isSameOrBefore(moment()) ? 5 : 4);
                                setActiveStep(4);
                                break;
                            case 7:
                                setActiveStep(6);
                                break;
                            case 8:
                                setActiveStep(7);
                                break;
                            case 9:
                                setActiveStep(7);
                                break;
                            case 10:
                                setActiveStep(8);
                                break;
                            case 11:
                                setActiveStep(8);
                                break;
                            default:
                                setActiveStep(-1);
                                break;
                        }
                        setState((st) => ({
                            ...st,
                            resData: data,
                            contractStatusID: data.contractStatusID,
                            deliveryArranged: data.deliveryArranged,
                            summerServiceScheduleID: data.summerServiceScheduleID,
                            onhireScheduleID: data.onhireScheduleID,
                            offhireScheduleID: data.offhireScheduleID,
                            factoryInspectionScheduleID: data.factoryInspectionScheduleID,
                            authorityReference: data.authorityReference,
                            winterEndDate: data.winterEndDate,
                            contractSummerServiceAreaID: data.contractSummerServiceAreaID,
                            contractDeliveryTransportCompanyID: data.contractDeliveryTransportCompanyID,
                            contractCollectionTransportCompanyID: data.contractCollectionTransportCompanyID,
                            contractOffhireDate: data.contractOffhireDate,
                            contractWinterEndDate: data.contractWinterEndDate,
                            checkedVehicleList: [{ vehicleContractID: data.vehicleContractID, contractVehicleID: data.contractVehicleID }],
                            vehicleContractID: data.vehicleContractID,
                            contractDeliveryDate: data.contractDeliveryDate
                        }));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        return fetchDropdown();
    }, [props.vehicleID, state.isUpdate, props.isReload]);

    useEffect(() => {
        try {
            let data = state.resData;
            let Steps = [
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 0 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step1}
                            </Grid>
                            <Grid item xs={12}>
                                <small style={{ fontSize: 10, fontWeight: 700 }}>
                                    <b>{data.summerServiceDue ? data.summerServiceDue : 'Schedule Not Set'}</b>
                                </small>
                            </Grid>
                            {data.summerServiceDue && data.summerServicCompleted ? (
                                <Grid item xs={12}>
                                    <small style={{ fontSize: 10, fontWeight: 700, color: data.summerServicCompleted ? 'black' : 'grey' }}>
                                        <b>{data.summerServicCompleted ? data.summerServicCompleted : 'Not Completed'}</b>
                                    </small>
                                </Grid>
                            ) : null}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 1 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step2}{' '}
                                {data.deliveryDocumentID && (
                                    <>
                                        {data.deliveryDocumentID ? (
                                            <span title="View Delivery Document">
                                                <VisibilityIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        ViewDownloadFile(data.deliveryDocumentID, 'DELIVERY');
                                                    }}
                                                />
                                            </span>
                                        ) : (
                                            <span title="Generate Delivery Document">
                                                <DescriptionIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        handleConfirmationModal('DELIVERY');
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </>
                                )}
                            </Grid>
                            {(activeStep >= 1 || state.contractDeliveryDate) && (
                                <>
                                    <Grid
                                        item
                                        xs={12}
                                        onClick={
                                            data.contractStatusID <= 3
                                                ? (e) => {
                                                      e.stopPropagation(); // prevent event bubbling
                                                      console.log('clicked');
                                                      setOpenDialog({ setDeliveryDateModal: true });
                                                      setChangeStatus(false);
                                                  }
                                                : () => false
                                        }
                                    >
                                        <small
                                            style={{
                                                fontSize: 10,
                                                fontWeight: 700,
                                                color: data.deliveryDate ? 'black' : 'grey',
                                                textDecoration: data.contractStatusID <= 3 ? 'underline' : 'none',
                                                cursor: data.contractStatusID <= 3 ? 'pointer' : 'default'
                                            }}
                                        >
                                            <b>{data.deliveryDate}</b>
                                        </small>
                                    </Grid>
                                    {data.deliveryCollectionDate && (
                                        <Grid item xs={12}>
                                            <small style={{ fontSize: 10, fontWeight: 700, color: data.deliveryDate ? 'black' : 'grey' }}>
                                                <b>{data.deliveryCollectionDate} </b>
                                            </small>
                                        </Grid>
                                    )}
                                </>
                            )}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 2 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step3}{' '}
                                {activeStep >= 2 && (
                                    <>
                                        {data.deliveryDocumentID ? (
                                            <span title="View Delivery Document">
                                                <VisibilityIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        ViewDownloadFile(data.deliveryDocumentID, 'DELIVERY');
                                                    }}
                                                />
                                            </span>
                                        ) : (
                                            <span title="Generate Delivery Document">
                                                <DescriptionIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        handleConfirmationModal('DELIVERY');
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </>
                                )}
                            </Grid>
                            {activeStep >= 2 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onsiteDate ? 'black' : 'grey' }}>
                                            <b>{data.deliveredBy}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onsiteDate ? 'black' : 'grey' }}>
                                            <b>{data.onsiteDate}</b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    ),
                    isClickable: data.onsiteDate === 'Onsite: Not set' && activeStep > 2 ? true : false
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 3 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step4}
                            </Grid>
                            {activeStep >= 3 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onhireServiceDue ? 'black' : 'grey' }}>
                                            <b>{data.onhireServiceDue}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onhireServiceCompleted ? 'black' : 'grey' }}>
                                            <b>{data.onhireServiceCompleted}</b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 4 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step5}
                            </Grid>
                            {activeStep >= 4 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onhireServiceCompleted ? 'black' : 'grey' }}>
                                            <b>{data.onhireDate}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.onhireServiceCompleted ? 'black' : 'grey' }}>
                                            <b>{data.winterEndDate}</b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 4 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step6}
                            </Grid>
                            {activeStep >= 4 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700 }}>
                                            <b>{data.offhireSetDate}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700 }}>
                                            <b> {data.offhireDate}</b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )
                },

                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 6 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step7}
                            </Grid>
                            {activeStep >= 6 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.offhireServiceDue ? 'black' : 'grey' }}>
                                            <b>{data.offhireServiceDue}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.offhireServiceCompleted ? 'black' : 'grey' }}>
                                            <b>{data.offhireServiceCompleted} </b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 7 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step8}{' '}
                                {activeStep >= 7 && (
                                    <>
                                        {data.collectionDocumentID ? (
                                            <span title="View Collection Document">
                                                <VisibilityIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        ViewDownloadFile(data.collectionDocumentID, 'COLLECTION');
                                                    }}
                                                />
                                            </span>
                                        ) : (
                                            <span title="Generate Collection Document">
                                                <DescriptionIcon
                                                    style={{ fontSize: 14, cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // prevent event bubbling
                                                        handleConfirmationModal('COLLECTION');
                                                    }}
                                                />
                                            </span>
                                        )}
                                    </>
                                )}
                            </Grid>
                            {activeStep >= 7 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.collectionDate ? 'black' : 'grey' }}>
                                            <b>{data.collectionDate}</b>
                                        </small>
                                    </Grid>
                                    {data.collectionStatus && (
                                        <Grid item xs={12}>
                                            <small style={{ fontSize: 10, fontWeight: 700, color: data.collectionStatus ? 'black' : 'grey' }}>
                                                <b>{data.collectionStatus} </b>
                                            </small>
                                        </Grid>
                                    )}
                                </>
                            )}
                        </Grid>
                    )
                },
                {
                    label: (
                        <Grid container className={classes.stepperlabel} style={{ cursor: activeStep == 8 ? 'pointer' : 'default' }}>
                            <Grid item xs={12} className={classes.stepLabel}>
                                {data.step9}
                            </Grid>
                            {activeStep >= 8 && (
                                <>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.factoryInspectionDue ? 'black' : 'grey' }}>
                                            Due: <b>{data.factoryInspectionDue ? data.factoryInspectionDue : 'Not Completed'}</b>
                                        </small>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <small style={{ fontSize: 10, fontWeight: 700, color: data.factoryInspectionCompleted ? 'black' : 'grey' }}>
                                            Completed: <b>{data.factoryInspectionCompleted ? data.factoryInspectionCompleted : 'Not Completed'} </b>
                                        </small>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    )
                }
            ];

            setState((st) => ({ ...st, steps: Steps }));
        } catch (error) {
            console.error(error);
        }
    }, [state.resData]);

    const handleSteps = (id = false) => {
        if (id) {
            setOpenDialog({ setOnsiteDateModal: true });
        } else {
            try {
                setState((st) => {
                    let newSt = { ...st };
                    let scheduleID = null;
                    if (st.contractStatusID == 1) newSt.scheduleID = st.summerServiceScheduleID;
                    if (st.contractStatusID == 5) newSt.scheduleID = st.onhireScheduleID;
                    if (st.contractStatusID == 7) newSt.scheduleID = st.offhireScheduleID;
                    // if (st.contractStatusID == 10) newSt.scheduleID = st.factoryInspectionScheduleID;
                    return newSt;
                });
            } catch (error) {
                console.warn(error);
            }
            try {
                let statusNextModal = '';

                if (state.contractStatusID == 1) {
                    statusNextModal = 'setDeliveryDateModal';
                    setChangeStatus(false);
                } else if (state.contractStatusID == 2 || !state.deliveryArranged) {
                    statusNextModal = 'setDeliveryDateModal';
                    setChangeStatus(true);
                } else if (state.contractStatusID == 3) statusNextModal = 'setCollectedModal';
                else if (state.contractStatusID == 4) statusNextModal = 'setOnsiteDateModal';
                // else if (state.contractStatusID == 5) statusNextModal = 'complete';
                else if (state.contractStatusID == 6) statusNextModal = 'setOffHireModal';
                else if (state.contractStatusID == 7) statusNextModal = 'OffHirecomplete';
                else if (state.contractStatusID == 8) statusNextModal = 'setVehiclePickedModal';
                else if (state.contractStatusID == 9) statusNextModal = 'setAwaitingFactoryInspection';
                // if (state.contractStatusID == 10) statusNextModal = 'setPauseCompleted';
                // if (state.contractStatusID == 11) statusNextModal = 'setResumeContract';
                else if (state.contractStatusID == 11) statusNextModal = 'setPauseCompleted';
                // if (state.contractStatusID == 10) statusNextModal = 'complete';

                setOpenDialog({ [statusNextModal]: true });
            } catch (error) {
                console.warn(error);
            }
        }
    };

    const closeSteps = () => {
        try {
            setState((st) => ({ ...st, modalIndex: -1, modalLabel: '' }));
            setModalStep(-1);
        } catch (error) {
            console.warn(error);
        }
    };

    const closeTheDialog = (res) => {
        setOpenDialog({});
        setChangeStatus(false);
        setState((st) => {
            const newSt = { ...st };
            newSt.isUpdate = new Date();
            return newSt;
        });

        // res && props.pullDetails();
        res && props.handleStepperContract(new Date());
    };

    const closeConfirmationModal = (res) => {
        setDocumentState((st) => {
            const newSt = { ...st };
            newSt.openModal = false;
            return newSt;
        });
    };
    const hideSingleDocViewerModal = (res) => {
        setDocumentState((st) => {
            const newSt = { ...st };
            newSt.showDocument = false;
            newSt.imageList = [];
            return newSt;
        });
    };

    const handleConfirmationModal = (type) => {
        setDocumentState((st) => {
            const newSt = { ...st };
            newSt.openModal = true;
            newSt.docType = type;
            return newSt;
        });
    };

    const submitDocModal = async () => {
        setDocumentState((st) => {
            const newSt = { ...st };
            newSt.isBtnLoader = true;
            return newSt;
        });
        let res = await VehicleContractReport(props.vehicleID, state.vehicleContractID, documentState.docType);
        if (res.success) {
            setDocumentState((st) => {
                const newSt = { ...st };
                newSt.openModal = false;
                newSt.isBtnLoader = false;
                return newSt;
            });
            setState((st) => {
                const newSt = { ...st };
                newSt.isUpdate = new Date();
                return newSt;
            });
            props.handleStepperContract(new Date());
            showToastSuccess(res.message || 'Document generated successfully');
        } else {
            setDocumentState((st) => {
                const newSt = { ...st };
                newSt.isBtnLoader = false;
                return newSt;
            });
            showToastError('Failed to generate document');
        }
    };

    const ViewDownloadFile = async (fileName, docType) => {
        setDocumentState((st) => ({ ...st, showDocument: true, docType: docType }));
        let success = await downloadUploadedFile(
            getConfigIdFromName('VehicleContracts'),
            state.vehicleContractID,
            fileName,
            `${docType}.pdf`,
            false,
            false,
            '.pdf'
        );
        if (success) {
            setDocumentState((st) => ({ ...st, imageList: success }));
        } else {
            showToastError(`Something went wrong, can't download file.`);
        }
    };

    return (
        <div className={classes.root}>
            {/* {state.resData.length > 0 && ( */}
            <Stepper alternativeLabel activeStep={activeStep} connector={width > 1024 ? <ColorlibConnector /> : <QontoConnector />}>
                {state.steps?.map((label, i) => {
                    return (
                        <Step key={label} onClick={i === activeStep || label.isClickable ? () => handleSteps(label.isClickable) : () => {}}>
                            {width < 500 ? (
                                <StepLabel StepIconComponent={(res) => <ColorlibStepIconTab {...res} />}> {activeStep === i ? label.label : null}</StepLabel>
                            ) : (
                                <StepLabel
                                    StepIconComponent={(res) =>
                                        width > 1024 ? (
                                            <ColorlibStepIcon {...res} contractDeliveryDate={state.contractDeliveryDate} activeStep={activeStep} />
                                        ) : (
                                            <ColorlibStepIconTab {...res} />
                                        )
                                    }
                                >
                                    {label.label}
                                </StepLabel>
                            )}
                        </Step>
                    );
                })}
            </Stepper>
            {/* )} */}

            {openDialog.OffHirecomplete ? (
                <DialogComp title={`Update Vehicle Location`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractOffHireOverRide
                        scheduleID={state.scheduleID}
                        onClose={closeTheDialog}
                        vehicleID={props.vehicleID}
                        // checkedVehicleList={state.checkedVehicleList}
                    />
                </DialogComp>
            ) : null}

            {openDialog.complete ? (
                <DialogComp title={`Complete Schedule`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <CompleteScheduleModalForContract scheduleID={state.scheduleID} onClose={closeTheDialog} />
                </DialogComp>
            ) : null}
            {openDialog.setDeliveryDateModal ? (
                <DialogComp title={`Arrange Delivery`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetDeliveryDateModal
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        contractDeliveryTransportCompanyID={state.contractDeliveryTransportCompanyID}
                        vehicleContractID={state.vehicleContractID}
                        changeStatus={changeStatus}
                        contractDeliveryDate={state.contractDeliveryDate}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setCollectedModal ? (
                <DialogComp title={`Collected`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetCollectedModal
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        contractDeliveryTransportCompanyID={state.contractDeliveryTransportCompanyID}
                        vehicleContractID={state.vehicleContractID}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setOnsiteDateModal ? (
                <DialogComp title={`Set Vehicle Onsite`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetOnsiteDateModal
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        vehicleContractID={state.vehicleContractID}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setOffHireModal ? (
                <DialogComp title={`Set Winter Off Hire`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetOffHireModal
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        authorityReference={state.resData.authorityReference}
                        winterEndDate={state.resData.contractOffhireDate}
                        contractWinterEndDate={state.resData.contractWinterEndDate}
                        selectedRecords={[
                            {
                                contractVehicleID: state.resData.contractVehicleID,
                                reg: state.resData.reg,
                                earliestOffHire: state.resData.earliestOffHire,
                                vehicleContractID: state.vehicleContractID
                            }
                        ]}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setVehiclePickedModal ? (
                <DialogComp title={`Arranged Collection`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetVehiclePickedModal
                        onClose={closeTheDialog}
                        contractSummerServiceAreaID={state.contractSummerServiceAreaID}
                        checkedVehicleList={state.checkedVehicleList}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setAwaitingFactoryInspection ? (
                <DialogComp title={`Set Vehicle Arrived Date`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetAwaitingFactoryInspection
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        contractCollectionTransportCompanyID={state.contractCollectionTransportCompanyID}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setPauseCompleted ? (
                <DialogComp title={`Contract Pause / Complete`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetPauseCompleted
                        onClose={closeTheDialog}
                        checkedVehicleList={state.checkedVehicleList}
                        vehicleID={props.vehicleID}
                        fromStepper={true}
                    />
                </DialogComp>
            ) : null}
            {openDialog.setResumeContract ? (
                <DialogComp title={`Resume Contract`} maxWidth="sm" fullWidth onClose={() => closeTheDialog(false)}>
                    <ContractSetResume onClose={closeTheDialog} checkedVehicleList={state.checkedVehicleList} />
                </DialogComp>
            ) : null}
            {documentState.openModal ? (
                <DialogComp title={`Warning`} maxWidth="sm" fullWidth onClose={() => closeConfirmationModal(false)}>
                    <ConfirmationModal
                        message={`Are you sure do you want to create a ${documentState.docType || ''} document`}
                        handleCancel={() => closeConfirmationModal(false)}
                        handleSubmit={submitDocModal}
                        isBtnLoader={documentState.isBtnLoader}
                    />
                </DialogComp>
            ) : null}
            {documentState.showDocument && (
                <DialogComp title={`Document - ${documentState.docType}`} onClose={hideSingleDocViewerModal} maxWidth="xl" fullWidth fullScreen>
                    <SingleDocumentViewer imageList={documentState.imageList || []} slectedFileExt={'.pdf'} />
                </DialogComp>
            )}

            {/* {getStepContent(modalStep)} */}
        </div>
    );
}
